import { render, staticRenderFns } from "./Conversas.vue?vue&type=template&id=2de8b2a4"
import script from "./Conversas.vue?vue&type=script&lang=js"
export * from "./Conversas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports